module.exports = __webpack_public_path__ + "static/media/sinatra.91f64bff.jpg";